import React from 'react';

import { Link } from '@eika/link';

import type { Link as LinkType } from '../../defaultConfig';
import type { Account, PaymentSubStatus, PaymentType, PaymentItem } from '../../generated-types';
import TranslationsConfigType from '../../translations/translationType';

type LinksForStoppedPayment = {
    paymentLimitsLink: LinkType | undefined;
    accountLink: LinkType | undefined;
    avtalegiroLink: LinkType | undefined;
};

const getLink =
    (
        translated: TranslationsConfigType,
        links: LinksForStoppedPayment,
        fromAccount: Account | undefined,
        useAvtalegiroLink = false,
    ) =>
    (status: PaymentSubStatus | undefined, paymentType: PaymentType): React.ReactNode => {
        switch (status) {
            case 'INSUFICIENT_FUNDS':
                return links.accountLink?.url && fromAccount ? (
                    <Link href={`${links.accountLink.url}?id=${fromAccount.accountId.value}`}>
                        {translated.stoppedPayments.goToAccount}
                    </Link>
                ) : null;
            case 'EXCEEDING_MAX_LIMIT':
                if (paymentType === 'AUTO_PAYMENT')
                    return useAvtalegiroLink && links.avtalegiroLink ? (
                        <Link href={links.avtalegiroLink.url}>{translated.stoppedPayments.findAvtalegiroHere}</Link>
                    ) : null;

                return links.paymentLimitsLink?.url ? (
                    <Link href={links.paymentLimitsLink.url}>{translated.stoppedPayments.editPaymentLimitsHere}</Link>
                ) : null;

            default:
                return null;
        }
    };

const getDescription = (
    translated: TranslationsConfigType,
    paymentSubStatus: PaymentSubStatus | undefined,
    paymentType: PaymentType,
) => {
    if (paymentSubStatus === 'EXCEEDING_MAX_LIMIT' && paymentType === 'AUTO_PAYMENT') {
        return translated.stoppedPayments.exeedingMaxLimitAvtalegiro;
    }
    return translated.stoppedPayments.detailedDescription[paymentSubStatus ?? 'UNKNOWN'];
};

const getDetailedStoppedDescriptionAndLink = (
    translated: TranslationsConfigType,
    links: LinksForStoppedPayment,
    fromAccount: Account | undefined,
    paymentItem: PaymentItem | undefined,
    useAvtalegiroLink = false,
) => {
    if (!paymentItem?.paymentItemType) return null;
    return {
        text: getDescription(translated, paymentItem.subStatus, paymentItem.paymentItemType),
        link: getLink(
            translated,
            links,
            fromAccount,
            useAvtalegiroLink,
        )(paymentItem.subStatus, paymentItem.paymentItemType),
    };
};
export default getDetailedStoppedDescriptionAndLink;
